import React, { useState } from "react";
import styles from "./introSection.module.css";
import { useDispatch } from "react-redux";
import { fetchArtistByCategory } from "../../redux/slices/artistSlice";

const Filter = ({ dimensions, category }) => {
  const [selectedValues, setSelectedValues] = useState({});
  const dispatch = useDispatch();

  const handleChange = (dimensionKey, value) => {
    let parsedValue = value;

    if (typeof value === "string") {
      try {
        parsedValue = JSON.parse(value);
      } catch (e) {
        // Value is not a JSON string, keep as-is
      }
    }
    setSelectedValues((prev) => ({
      ...prev,
      [dimensionKey]: parsedValue,
    }));
  };

  const handleFindArtistClick = () => {
    if (category) {
      dispatch(
        fetchArtistByCategory({ ...selectedValues, category: category })
      );
      return;
    }
    dispatch(fetchArtistByCategory({ selectedValues }));
  };

  return (
    <div className={styles.searchBar}>
      <div className={styles.searchBarInner}>
        {dimensions.map((dimension) => (
          <select
            key={dimension.key}
            className={styles.searchSelect}
            onChange={(e) => handleChange(dimension.key, e.target.value)}
          >
            <option value="">{dimension.label}</option>
            {dimension.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ))}

        <button
          className={`${styles.searchButton} ${styles.shimmerEffect}`}
          onClick={handleFindArtistClick}
        >
          <span className={styles.buttonContent}>
            <svg
              className={styles.searchIcon}
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path
                fill="currentColor"
                d="M21.707 20.293l-5.395-5.396A7.952 7.952 0 0016 10c0-4.411-3.589-8-8-8S0 5.589 0 10s3.589 8 8 8a7.952 7.952 0 004.897-1.688l5.396 5.395A.998.998 0 0020 22a.999.999 0 00.707-1.707zM8 16c-3.309 0-6-2.691-6-6s2.691-6 6 6-2.691 6-6 6z"
              />
            </svg>
            Find Artists
          </span>
        </button>
      </div>
    </div>
  );
};

export default Filter;
